import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,
});

export function setAuthToken(token) {
    if (token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        localStorage.setItem("edu_token", token);
    } else {
        delete api.defaults.headers.common["Authorization"];
        localStorage.removeItem("edu_token");
    }
}

const stored = typeof window !== "undefined" ? localStorage.getItem("edu_token") : null;
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

// Silent handler: 401 redirects to login; 403 is propagated as a soft error
// without spamming the user with overlay popups. Pages should still .catch() and
// decide whether to toast or ignore. We mark the error so navigation handlers
// can quietly skip these.
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        if (status === 401) {
            // Session expired — clear token and route to /login (only if not already there)
            try {
                setAuthToken(null);
            } catch (_) {}
            if (typeof window !== "undefined" && window.location.pathname !== "/login") {
                window.location.replace("/login");
            }
            error.silent = true;
        } else if (status === 403) {
            // Forbidden for this route/role - mark silent so callers can decide
            error.silent = true;
        }
        return Promise.reject(error);
    },
);

export function fileUrl(fileId) {
    const token = localStorage.getItem("edu_token");
    const auth = token ? `?auth=${encodeURIComponent(token)}` : "";
    return `${BACKEND_URL}/api/files/${fileId}/download${auth}`;
}

export function formatDetail(detail) {
    if (detail == null) return "Algo salió mal. Intenta de nuevo.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
